<li>
	<div class="activity-icon" />
	<div class="activity-inner">
		<div class="activity-title" />
		<div class="activity-meta" />
		<div class="activity-button" />
	</div>
</li>

<style>
	li {
		display: flex;
		position: relative;
		block-size: 81px;
		padding-block: 18px;
		padding-inline: 0;
	}

	.activity-icon {
		block-size: 36px;
		inline-size: 36px;
		margin-inline-end: 9px;
		border-radius: 18px;
		background-color: var(--placeholderColor);
	}

	.activity-inner {
		position: relative;
		flex: auto;
	}

	.activity-title {
		block-size: 8px;
		inline-size: 60%;
		margin-block: 5px 9px;
		margin-inline: 0;
		border-radius: 9px;
		background-color: var(--placeholderColor);
	}

	.activity-meta {
		block-size: 8px;
		inline-size: 40%;
		border-radius: 9px;
		background-color: var(--placeholderColor);
	}

	.activity-button {
		display: block;
		position: absolute;
		block-size: 27px;
		inline-size: 63px;
		margin-block-start: 5px;
		border-radius: 5px;
		background-color: var(--placeholderColor);
		color: #000;
		font-size: 1.1rem;
		line-height: 25px;
		text-align: center;
		inset-block-start: 0;
		inset-inline-end: 0;
	}

	.activity-button:hover {
		cursor: pointer;
	}
</style>
